import React from 'react';
import '../../styles/components/HomeSection/MarketButtons.css';

interface AppStoreButtonProps {
}

const AppStoreButton: React.FC<AppStoreButtonProps> = () => {
  return (
    <a 
      href="https://apps.apple.com/app/rushhour-parking-jam-solution/id6754037494" 
      target="_blank" 
      rel="noopener noreferrer"
      className="market-btn apple-btn"
    >
      <span className="market-button-subtitle">Download on the</span>
      <span className="market-button-title">App Store</span>
    </a>
  );
};

export default AppStoreButton;
